import { State } from "../../store"

export const getAuthState = (state: State) => state.auth
